<template>
  <div class="header-container">
    <div :class="['top-box', $route.path === '/' ? 'bg_1' : 'bg_2']">
      <div :class="['header-top', 'flex', 'jc_sb', 'align_items_ctr']">
        <div class="left-logo pointer" v-if="$route.path === '/'" @click="$router.push('/')"></div>
        <div class="txt-logo pointer" v-else @click="$router.push('/')"></div>
        <div :class="[$route.path === '/' && 'center-tabs', 'flex', 'align_items_ctr']">
          <div
            :class="['path-tab', 'pointer', 'flex', currentPath === item.path && 'active-tab']"
            v-for="(item, index) in navsList"
            @click="changeTab(item.path, index)"
            :key="index"
          >
            {{ item.label }}
            <!-- <div class="" v-if="item.path === '/topics'">
              <el-dropdown placement="bottom">
                <span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in topics"
                    :key="index"
                    @click.native="$router.push(`${item.path}?name=${encodeURIComponent(encodeURIComponent(item.name))}`)"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
          </div>
        </div>
        <div :class="['right-btns', 'flex', 'align_items_ctr', $route.path === '/' && 'margin-auto']">
          <div class="old-btn pointer" v-if="false&&($route.path === '/')" @click="goOldSite">切换旧版</div>
          <transition>
            <div class="search-btn pointer" v-show="$route.path !== '/'" @click="changeSearchShow"><i class="el-icon-search"></i>快速检索</div>
          </transition>
          <div class="sta-btn pointer" @click="$router.push('/data_statistics')">统计</div>
          <div class="login-btn pointer" @click="toLogin" v-if="userInfo.userName === 'guest'">登录</div>
          <div v-else>
            <el-dropdown placement="bottom">
              <span class="fs_12" style="color: #ffcc00; cursor: pointer; font-size: 18px">{{ userInfo.unit || userInfo.realName || userInfo.userName }} </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="userInfo.userType === 1" @click.native="$router.push('/myCenter?type=0')">个人中心</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push('/login')">切换账号</el-dropdown-item>
                <el-dropdown-item @click.native="Logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getIp, logout } from '@/apis/index.js'
import autoLogin from '@/utils/autoLogin.js'
import { mapState } from 'vuex'
import store from '@/store'
export default {
  name: 'HeaderCom',
  inject: ['reload'],
  data() {
    return {
      currentNavIndex: 0,
      navsList: [
        { label: '首页', path: '/' },
        { label: '成果', path: '/achievements' },
        { label: '动态', path: '/dynamic' },
        { label: '专家', path: '/expert' },
        { label: '机构', path: '/organization' },
        { label: '领域', path: '/topics' },
      ],
      key: '',
      currentPath: '/',
      topics: [
        {
          icon: 'pol',
          name: '政治',
          path: '/topics/politics',
        },
        {
          icon: 'eco',
          name: '经济',
          path: '/topics/economics',
        },
        {
          icon: 'tech',
          name: '科技',
          path: '/topics/technology',
        },
        {
          icon: 'cul',
          name: '教育',
          path: '/topics/teach',
        },
        {
          icon: 'social',
          name: '社会',
          path: '/topics/social',
        },
        {
          icon: 'env',
          name: '环境',
          path: '/topics/environment',
        },
        {
          icon: 'milt',
          name: '军事',
          path: '/topics/military',
        },
        {
          icon: 'energy',
          name: '能源',
          path: '/topics/energy',
        },
        {
          icon: 'health',
          name: '健康',
          path: '/topics/health',
        },
        {
          icon: 'agriculture',
          name: '农业',
          path: '/topics/agriculture',
        },
      ],
      userName: '',
      // isShowQuickSearch: false,
    }
  },
  computed: {
    ...mapState(['userInfo', 'showQuickSearch']),
  },
  async mounted() {
    await this.init()
  },
  methods: {
    changeSearchShow() {
      //改变搜索栏显示隐藏，同时清空输入框的值
      // this.showQuickSearch = !this.showQuickSearch
      this.$store.commit('setShowQuickSearch', !this.showQuickSearch)
      this.$store.commit('setSearchKey', '')
    },
    changeTab(path, index) {
      if (this.$route.path === path) return
      this.currentPath = path
      this.$router.push(path)
    },
    toLogin() {
      this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
    },
    
    async init() {
      this.$store.commit('isCreatePage', false)
      let res = await autoLogin.myLogin()
      this.userName = this.userInfo.userName
      // if (res) {
      // } else {
      // }
    },
    Logout() {
      let token = sessionStorage.getItem('token')
      logout(token).then((res) => {
        if (res.success) {
          sessionStorage.clear()
          localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage))
          localStorage.setItem('changeSessionStorage', Date.now())
          localStorage.removeItem('changeSessionStorage')
          this.$router.push('/login')
          this.$message({
            type: 'success',
            message: res.msg,
          })
        }
      })
    },
    goOldSite() {
      window.open('http://v2-tds.sunwayinfo.com.cn')
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newV, oldV) {
        if (this.$route.path === '/') {
          this.currentPath = '/'
        } else {
          let arr = ['/achievements', '/dynamic', '/expert', '/organization', '/topics']
          let pIndex = arr.findIndex((item) => this.$route.path.includes(item))
          this.currentPath = pIndex === '-1' ? '' : arr[pIndex]
        }
        this.$store.commit('setShowQuickSearch', false)
        this.$store.commit('setSearchKey', '')
      },
    },
  },
}
</script>
<style lang="less" scoped>
.header-container {
  position: sticky;
  top: 0;
  z-index: 2001; //el-laoding-mask z-index 2000
}
.top-box {
  width: 100%;
  height: 81px;
  background-size: cover;
  background-position: center center;
  position: relative;
}
.bg_1 {
  background-image: url(../assets/header/top_1.jpg);
}
.bg_2 {
  background-image: url(../assets/header/top_2.jpg);
}
.header-top {
  height: 100%;
  width: 1600px;
  position: sticky;
  margin: 0 auto;
  padding: 0 12px;
  box-sizing: border-box;
  .left-logo {
    width: 44px;
    height: 44px;
    background-image: url(../assets/icons/logo.png);
    background-size: contain;
  }
  .txt-logo {
    width: 205px;
    height: 44px;
    background-image: url(../assets/icons/logo-txt.png);
    background-size: contain;
  }
  .center-tabs {
    margin-left: 40px;
  }
  .path-tab {
    color: #03133d;
    &:not(:first-child) {
      margin-left: 40px;
    }
  }
  .active-tab {
    font-weight: bold;
  }
  .right-btns {
    font-size: 14px;
    color: #03133d;
  }
  .margin-auto {
    margin-left: auto;
  }
  .tran-btn {
    margin-right: 40px;
    &::before {
      content: '';
      margin-top: -3px;
      margin-right: 4px;
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url(../assets/icons/tran.png);
    }
  }
  .search-btn {
    margin-right: 40px;
    i {
      margin-right: 8px;
    }
  }
  .user-name {
    font-weight: bold;
    color: rgb(255, 204, 0);
  }

  .sta-btn {
    margin-right: 40px;
    &::before {
      content: '';
      margin-top: -3px;
      margin-right: 4px;
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url(../assets/icons/statics.png);
    }
  }
  .old-btn {
    margin-right: 40px;
    &::before {
      content: '';
      margin-top: -3px;
      margin-right: 4px;
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url(../assets/icons/old.png);
    }
  }
  .login-btn {
    width: 76px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #03133d;
  }
}
</style>
<style lang="less">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.el-dropdown-menu {
  width: 100px;
}
.el-dropdown-menu__item {
  width: 100px;
}
</style>
